const getRadiusParse = (amount: number, lang: string): string =>
  new Intl.NumberFormat(lang === 'en' ? 'en-US' : 'fr-FR', {
    maximumFractionDigits: 2,
  }).format(amount);

export default getRadiusParse;
